export default {
  // ljy语言配置
  Each_SKU_storage_fee_calculation_starts_from_the_batch_entry_date:
    "每个SKU入库批次开始计算仓租天数",
  Dispatch_return_items: "下发退件",
  Only_save_the_hour_minute_and_second_of_the_confirmation_time:
    "仅保存确认时间的时分秒",
  When_conducting_a_quick_search: "快捷查询时",
  the_default_end_date_is_set_to_today_date: "默认结束日期为今日日期",
  Query_the_start_date_based_on_the_saved_time_period_in_real_time:
    "根据保存的时间段实时查询开始日期",
  Today_delivery: "今日达",
  Nextday_delivery: "次日达",
  Today_delivery_Platform: "平台今日达",
  Today_delivery_Shopee: "Shopee今日达",
  Nextday_delivery_Shopee: "Shopee次日达",
  Today_delivery_Lazada: "Lazada今日达",
  Nextday_delivery_Lazada: "Lazada次日达",
  Today_delivery_Tiktok: "Tiktok今日达",
  Nextday_delivery_Tiktok: "Tiktok次日达",
  Today_delivery_Temu: "Temu今日达",
  Nextday_delivery_Temu: "Temu次日达",
  You_cannot_choose_both_today_and_next_day_delivery:
    "不能同时选择今日达与次日达",
  Has_Invoice: "有无发票",
  The_file_naming_format_is_incorrect_the_last_item_must_be_the_invoice_serial_number_id_a_pure_number:
    "文件命名格式不正确，最后一项必须是发票流水号id（纯数字）",
  manageAddTransferOutTask: "创建移仓迁出任务",
  manageEditTransferOutTask: "编辑移仓迁出任务",
  No_available_goods: "暂无可用商品",
  One_click_transfer_out_goods: "一键迁出商品",
  Select_Inventory_Product: "选择库存商品",
  Pickup_at_location: "上门",
  Delivery_service: "快递",
  Truk_delivery: "卡派",
  transfer_out_type: "迁出类型",
  Failed_to_retrieve_current_logged_in_customer_information:
    "获取当前登录客户信息失败",
  ATrigger_an_alert_when_the_current_time_minus_the_task_start_time_exceeds_the_warning_threshold_notify_the_corresponding_account_of_the_role_in_their_to_do_list:
    "当前时间-任务开始时间＞预警值时触发预警；通知到角色对应账号的待办中",
  Trigger_an_alert_when_the_inventory_quantity_at_a_storage_location_is_below_the_warning_threshold_and_there_is_stock_available_in_backup_or_temporary_locations:
    "库位库存数量＜预警值，且在备货或临时库位有货的情况下触发预警；",
  The_notification_will_be_sent_to_the_corresponding_role_s_account_as_a_pending_task:
    "通知到角色对应账号的待办中",
  Return_Order_Daily_Logistics_Page: "每日物流退件收货报表",
  Return_Order_Daily_Logistics_Customer_Page: "每日客户物流退件收货报表",
  Return_Order_Daily_Logistics_Product_Page: "每日客户退货商品收货报表",
  Return_Order_Monthly_Logistics_Product_Page: "每月客户退货商品收货报表",
  Please_select_the_customer_company: "请选择客户公司",
  isolated_storage_location_up: "隔离库位上架",
};
